
/**
 * Horizon overrides for Shopify.actions.
 * Suppress native Shopify cart opening after a homepage Best Seller add.
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  document.addEventListener('click', function (event) {
    const target = event.target instanceof Element
      ? event.target
      : event.target?.parentElement;

    if (
      target?.closest(
        'body.template-index .bs-product-form .bs-add-to-cart, ' +
        'body.template-index .bs-add-to-cart'
      )
    ) {
      window.__dojoSuppressNativeCartUntil = Date.now() + 5000;
    }
  }, true);

  actions.updateCart.configure({
    eventTarget: () =>
      document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      if (window.__dojoSuppressNativeCartUntil > Date.now()) {
        window.__dojoSuppressNativeCartUntil = 0;
        return;
      }

      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
